import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { BlockableDiv } from '../../../../shared/controls/blockable-div/blockable-div.component';
import { BaseDetailComponent } from '../../../../common/base-detail.component';
import { Address } from '../../../../generated/generated-types';
import { OpenItemPaymentCombinedListWidgetComponent } from '../open-item-payment-combined-list-widget/open-item-payment-combined-list-widget.component';

@Component({
  selector: 'app-formly-open-item-payment-list',
  templateUrl: './formly-open-item-payment-list.component.html',
  standalone: true,
  imports: [
    BlockableDiv,
    OpenItemPaymentCombinedListWidgetComponent,
    ButtonModule,
    TooltipModule,
    TranslatePipe,
  ]
})
export class FormlyOpenItemPaymentListComponent extends FieldType implements OnInit {

  addressId: string;
  cdRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  isSaving: boolean = false;

  constructor(

  ) {
    super();
  }

  ngOnInit(): void {
    if (this.model) {
      this.addressId = this.model[this.key as string]; // The key is comming from the formly field definition[fallbacks]
    }

    this.formControl.valueChanges.subscribe((model: string) => {
      let addressId = model;
      if (this.addressId != addressId) {
        this.addressId = addressId;
        this.cdRef.detectChanges();
      }
    })

  }

  checkIfCanSave() {
    let component = this.options.formState.detailComponent as BaseDetailComponent<Address>;
    return component.detailForm.invalid;
  }

  async saveToUnlockEditMode() {

    //Other options would be to use the service, but special overwrite in the component wont be used then

    let component = this.options.formState.detailComponent as BaseDetailComponent<Address>;
    if (!component) {
      console.error("No detail component found to save Asset");
      return;
    }

    this.isSaving = true;
    this.cdRef.detectChanges();

    await component.save();

    this.isSaving = false;
    this.cdRef.detectChanges();
  }

}